import React from "react";

interface CopyIconProps {
  color?: string;
  size?: number;
}

export function CopyIcon({ color = "#0056D6", size = 16 }: CopyIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <rect
        x="7.5"
        y="2.5"
        width="10"
        height="12"
        rx="1.5"
        stroke={color}
        strokeWidth="1.2"
      />
      <path
        d="M12.5 14.5V16C12.5 16.8284 11.8284 17.5 11 17.5H4C3.17157 17.5 2.5 16.8284 2.5 16V7C2.5 6.17157 3.17157 5.5 4 5.5H5.5"
        stroke={color}
        strokeWidth="1.2"
      />
    </svg>
  );
}
